var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}]},[_c('div',{staticClass:"delete-dialog-box",on:{"click":_vm.deleteImg}},[_vm._v(" 删除图片 ")]),_c('div',{staticClass:"shadow",on:{"click":_vm.show}})])}
var staticRenderFns = []

export { render, staticRenderFns }